const STATUS_SELECTOR = '.event-card-status-title[data-time]';
const STATUS_WRAP_SELECTOR = '.event-card-status';
const CARD_SELECTOR = '.event-card';
const CARD_PAST_MODIFIER = 'event-card--past';

export type EventStatusKind = 'past' | 'today' | 'open';

const STATUS_LABEL: Record<EventStatusKind, string> = {
  past: 'Прошедшее',
  today: 'Сегодня',
  open: 'Регистрация открыта',
};

const STATUS_MODIFIER: Record<EventStatusKind, string> = {
  past: 'event-card-status--past',
  today: 'event-card-status--today',
  open: 'event-card-status--open',
};

const ALL_MODIFIERS = Object.values(STATUS_MODIFIER);

/** Парсит дату Bitrix DateTime (DD.MM.YYYY HH:MM:SS) и ISO-подобные строки. */
export function parseEventDateTime(value: string): Date | null {
  const trimmed = value.trim();
  if (!trimmed) return null;

  const bitrixMatch = trimmed.match(
    /^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?/,
  );
  if (bitrixMatch) {
    const [, day, month, year, hours = '0', minutes = '0', seconds = '0'] = bitrixMatch;
    const parsed = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hours),
      Number(minutes),
      Number(seconds),
    );
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const parsed = new Date(trimmed);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function calendarDayTimestamp(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}

export function resolveEventStatus(
  dateTimeRaw: string,
  now = new Date(),
): { kind: EventStatusKind; label: string } | null {
  const eventDate = parseEventDateTime(dateTimeRaw);
  if (!eventDate) return null;

  const eventDay = calendarDayTimestamp(eventDate);
  const today = calendarDayTimestamp(now);

  let kind: EventStatusKind;
  if (eventDay < today) {
    kind = 'past';
  } else if (eventDay > today) {
    kind = 'open';
  } else {
    kind = 'today';
  }

  return { kind, label: STATUS_LABEL[kind] };
}

export function resolveEventStatusLabel(dateTimeRaw: string, now = new Date()): string {
  return resolveEventStatus(dateTimeRaw, now)?.label ?? '';
}

function applyStatusToElement(titleEl: HTMLElement, status: { kind: EventStatusKind; label: string }): void {
  const wrap = titleEl.closest<HTMLElement>(STATUS_WRAP_SELECTOR);
  const card = titleEl.closest<HTMLElement>(CARD_SELECTOR);
  titleEl.textContent = status.label;

  if (!wrap) return;

  wrap.classList.remove(...ALL_MODIFIERS);
  wrap.classList.add(STATUS_MODIFIER[status.kind]);
  wrap.dataset.status = status.kind;

  if (card) {
    card.classList.toggle(CARD_PAST_MODIFIER, status.kind === 'past');
  }
}

export function refreshEventStatusLabels(root: ParentNode = document): void {
  root.querySelectorAll<HTMLElement>(STATUS_SELECTOR).forEach((el) => {
    const raw = el.dataset.time?.trim();
    if (!raw) return;

    const status = resolveEventStatus(raw);
    if (!status) return;

    applyStatusToElement(el, status);
  });
}
